import { Label } from "@/components/ui/label";

type Props = {
  htmlFor: string;
  children: React.ReactNode;
  trailing?: React.ReactNode;
};

/** Wrapping every label in the same flex container keeps the row's
 *  box height stable whether the `trailing` slot is present or not. */
export function LabelRow({ htmlFor, children, trailing }: Props) {
  return (
    <div className="flex items-center justify-between">
      <Label htmlFor={htmlFor}>{children}</Label>
      {trailing}
    </div>
  );
}
